import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from '../../../contexts/AuthContext'
import PuestosCreate from "./PuestosCreate";
import axios from "axios";
import { Table, 
  Input, 
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label, } from "reactstrap";
import Header from "../../../layout/Header/Header";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable"
import useFullPageLoader from "../../../hooks/useFullPageLoader"
import { puede } from "../../../../permisos/permisos";

function ListadoPuestos() {
  const { user } = useContext(AuthContext);
  const URL_PUESTOS = process.env.REACT_APP_URL_PUESTOS;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const URL_PLANTELES = process.env.REACT_APP_URL_PLANTELES;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const PLANTELES_GENERAL = process.env.REACT_APP_PLANTELES_GENERAL;
  const AREAS_GENERAL = process.env.REACT_APP_AREAS_GENERAL;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState('');
  const [puestos, setPuestos] = useState([]);
  const [selectedPuesto, setSelectedPuesto] = useState('');
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");
  const [planteles, setPlanteles] = useState([]);
  const [selectedPlantel, setSelectedPlantel] = useState('');
  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);
  const [text, setText] = useState(false);
  const [idPuesto, setIdPuesto] = useState("")
  const [nombrePuesto, setNombrePuesto] = useState("")
  const [idColaboradores, setIdColaboradores] = useState("")
  const [idArea, setIdArea] = useState("")
  const [idPlantel, setIdPlantel] = useState("")

  //Edit 
  const [idColaboradoresEdit, setIdColaboradoresEdit] = useState("")
  const [idAreaEdit, setIdAreaEdit] = useState("")
  const [idPlantelEdit, setIdPlantelEdit] = useState("")

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const [puesto, setPuesto] = useState("");

  const [modalCreate, setModalCreate] = useState(false);
  const toggleCreate = () => setModalCreate(!modalCreate);

const ITEMS_PER_PAGE = 50

  useEffect(() => {
    axios
      .get(URL_PUESTOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allPuestos = response.data;
        let arrayTabla = allPuestos
        .sort((a, b) => (a.name > b.name ? 1 : -1))
        .map((a) => {
          return {
            _id:a._id,
            name: a.name,
            nombreColaboradores: a.colaboradores[0].nombre + " " + a.colaboradores[0].apellido,
            idColaboradores: a.colaboradores[0]._id,
            nombrePlantel: a.planteles[0].name,
            idPlantel: a.planteles[0]._id,
            nombreArea: a.areas[0].name,
            idArea: a.areas[0]._id,
            is_active: a.is_active

          };
        }).filter(function (el) {
          return el != null;
        });

        let dataFinal = Object.values(arrayTabla);
        setPuestos(allPuestos)
        setComments(dataFinal)
      })
      .catch((err) => {
        console.log(err);
      });
      axios
      .get(URL_PLANTELES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allPlanteles = response.data;
        setPlanteles(allPlanteles);
      })
      .catch((err) => {
        console.log(err);
      });
      axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allAreas = res.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });
      axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allColaboradores = response.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function Edit(idPuesto, nombrePuesto, idColaboradores, idArea, idPlantel){
      setIdPuesto(idPuesto)
      setNombrePuesto(nombrePuesto)
      setIdColaboradoresEdit(idColaboradores)
      setIdAreaEdit(idArea)
      setIdPlantelEdit(idPlantel)
      toggleEdit()
    }

  function editPuesto(event) {
    event.preventDefault();
  const URL_PUESTOS_EDIT = `${process.env.REACT_APP_URL_PUESTOS}/${idPuesto}`;
    axios
      .patch(
        URL_PUESTOS_EDIT,
        {
          name: nombrePuesto,
          areas:idAreaEdit,
          colaboradores: idColaboradoresEdit,
          planteles: idPlantelEdit
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios
        .post(
          URL_LOGS,
          {
            tipo:'Edito Puestos Admin',
            detalle: `Nombre: ${nombrePuesto}`,
            user: user.id
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        toggleEdit();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        window.location.reload();
      })
       .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

// pagination
const headers = [
  { name: "Puesto", field: "name", sortable: true },
  { name: "Jefe", field: "nombreColaboradores", sortable: true },
  // { name: "Plantel", field: "nombrePlantel", sortable: true },
  // { name: "Area", field: "nombreArea", sortable: true },
  { name: "Acciones", field: "acciones", sortable: false },
];

const commentsData = useMemo(() => {
  let computedComments = comments

  if (search) {
      computedComments = computedComments.filter(
          comment =>
              comment.name.toLowerCase().includes(search.toLowerCase()) ||
              comment.nombreColaboradores.toLowerCase().includes(search.toLowerCase()) 
              // ||
              // comment.nombrePlantel.toLowerCase().includes(search.toLowerCase()) ||
              // comment.nombreArea.toLowerCase().includes(search.toLowerCase()) 
      );
  }

  if(user.planteles != PLANTELES_GENERAL){
    computedComments = computedComments.filter((e)=>
    e.idPlantel.includes(user.planteles)
    ) 
  } 

  if(user.areas != AREAS_GENERAL){
    computedComments = computedComments.filter((e)=>
    e.idArea.includes(user.areas)
    ) 
  } 

  if(puesto){
    computedComments = computedComments.filter((e)=>
    e._id.includes(puesto)
    ) 
  } 

  if(idColaboradores){
    computedComments = computedComments.filter((e)=>
    e.idColaboradores.includes(idColaboradores)
    ) 
  } 
  
  // if(idPlantel){
  //   computedComments = computedComments.filter((e)=>
  //   e.idPlantel.includes(idPlantel)
  //   ) 
  // } 

  // if(idArea){
  //   computedComments = computedComments.filter((e)=>
  //   e.idArea.includes(idArea)
  //   ) 
  // }


  setTotalItems(computedComments.length);

  //Sorting comments
  if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
          (a, b) =>
              reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
  }

  //Current Page slice
  return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
  );
}, [comments, currentPage, search, sorting, idPlantel, idArea, idColaboradores, puesto]);



// 

  return (
    <>
      <Header />
      <br />
      <br />
      {puede(user, "empleados.puestos.ver")  ?(
        <div className="container">
          <div className="card col-12">
                  <div className="page-header">
                    <div>
                      <h3 className="page-title">
                        <i className="fas fa-id-badge" style={{ marginRight: 8, color: "#6366f1" }} />
                        Puestos
                      </h3>
                    </div>
                    <div className="page-actions">
                      <Button size="sm" color="success" onClick={toggleCreate}>
                        <i className="fas fa-plus" style={{ marginRight: 6 }} /> Nuevo Puesto
                      </Button>
                    </div>
                  </div>
                  <div className="row">
                        <div className="col-md-6">
                            <Pagination
                                total={totalItems}
                                itemsPerPage={ITEMS_PER_PAGE}
                                currentPage={currentPage}
                                onPageChange={page => setCurrentPage(page)}
                            />
                        </div>
                        <div className="col-md-6 d-flex flex-row-reverse">
                            <Search
                                onSearch={value => {
                                    setSearch(value);
                                    setCurrentPage(1);
                                }}
                            />
                        </div>
                    </div>
            <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
                <TableHeader
                            headers={headers}
                            onSorting={(field, order) =>
                                setSorting({ field, order })
                            }
                        />
                <tr>
                      {user.planteles == PLANTELES_GENERAL && user.areas == AREAS_GENERAL? 
                        <td style={{ paddingTop: "0px" }}>
                        <Input
                        bsSize="sm"
                        type="select"
                        value={puesto}
                        required
                        onChange={(e) => {
                          setPuesto(e.target.value)
                          setCurrentPage(1)
                        }}
                      >
                        <option value="">Selecciona</option>
                        {puestos
                          .sort((a, b) => a.name > b.name ? 1 : -1 )
                          .map((a) => {
                          return <option value={a._id}>{a.name} </option>;
                          })}
                      </Input>
                        </td> :
                      <td style={{ paddingTop: "0px" }}>
                      <Input
                      bsSize="sm"
                      type="select"
                      value={puesto}
                      required
                      onChange={(e) => {
                        setPuesto(e.target.value)
                        setCurrentPage(1)
                      }}
                    >
                      <option value="">Selecciona</option>
                      {puestos
                        .sort((a, b) => a.name > b.name ? 1 : -1 )
                        .map((a) => {
                          if(user.planteles == a.planteles[0]._id && user.areas == a.areas[0]._id){
                        return <option value={a._id}>{a.name} </option>;}
                        })}
                    </Input>
                      </td>  
                      }
                       {user.planteles == PLANTELES_GENERAL && user.areas == AREAS_GENERAL?
                      (<td style={{ paddingTop: "0px" }}>
                        <Input
                        bsSize="sm"
                        type="select"
                        value={idColaboradores}
                        required
                        onChange={(e) => setIdColaboradores(e.target.value)}
                      >
                        <option value="">Selecciona</option>
                        {colaboradores
                          .sort((a, b) => a.nombre > b.nombre ? 1 : -1 )
                          .map((a) => {
                          return <option value={a._id}>{a.nombre} {a.apellido}</option>;
                          })}
                      </Input>
                        </td>):(
                        <td style={{ paddingTop: "0px" }}>
                        <Input
                        bsSize="sm"
                        type="select"
                        value={idColaboradores}
                        required
                        onChange={(e) => setIdColaboradores(e.target.value)}
                      >
                        <option value="">Selecciona</option>
                        {colaboradores
                          .sort((a, b) => a.nombre > b.nombre ? 1 : -1 )
                          .map((a) => {
                            if(user.planteles == a.planteles[0]._id && user.areas == a.areas[0]._id){
                              return (<option value={a._id}>{a.nombre} {a.apellido}</option>)}
                          })}
                      </Input>
                        </td>
                        )}
                        {/* {user.planteles == PLANTELES_GENERAL ? (
                    <td style={{ paddingTop: "0px" }}>
                      <Input
                        bsSize="sm"
                        type="select"
                        value={idPlantel}
                        onChange={(e) => setIdPlantel(e.target.value)}
                      >
                        <option value="">Selecciona</option>
                        {planteles
                          .sort((a, b) => a.name - b.name)
                          .map((a) => {
                              return <option value={a._id}>{a.name}</option>
                          })}
                      </Input>
                    </td>
                  ) : (
                    <td></td>
                  )}
                  {user.areas == AREAS_GENERAL ? (
                    <td style={{ paddingTop: "0px" }}>
                      <Input
                        bsSize="sm"
                        type="select"
                        value={idArea}
                        onChange={(e) => setIdArea(e.target.value)}
                      >
                        <option value="">Selecciona</option>
                        {areas
                          .sort((a, b) => a.name - b.name)
                          .map((a) => {
                              return <option value={a._id}>{a.name}</option>
                          })}
                      </Input>
                    </td>
                  ) : (
                    <td></td>
                  )} */}
                      </tr>
                    <tbody>
                      {
                      commentsData.map((p) => {
                        return (
                          <tr>
                            <td>{p.name}</td>
                            <td>{p.nombreColaboradores}</td>
                            {/* <td>{p.nombrePlantel}</td>
                            <td>{p.nombreArea}</td> */}
                            <td>         
                              {puede(user, "empleados.puestos.crear")  ?(
                                <Button color="info" id="Editar" size="sm" onClick={(e)=>Edit(p._id, p.name, p.idColaboradores,
                                  p.idArea, p.idPlantel)}>
                                    <i class="far fa-edit"></i>
                                  </Button>
                              ):(
                                <Button color="info" id="Editar" size="sm" disabled>
                                  <i class="far fa-edit"></i>
                                </Button>
                              )}
                                  <Baja idStatus={p._id} is_active={p.is_active} URL_BAJA={process.env.REACT_APP_URL_PUESTOS} />
                            
                              </td>
                          </tr>
                        );
                        }
                      )}
                    </tbody>
                  </Table>
          </div>
        </div>
      ): undefined }

      {/* Modal de alta */}
      <Modal size="lg" isOpen={modalCreate} toggle={toggleCreate}>
        <ModalHeader toggle={toggleCreate}>
          <i className="fas fa-plus" style={{ marginRight: 8 }} />
          Nuevo Puesto
        </ModalHeader>
        <ModalBody>
          <PuestosCreate />
        </ModalBody>
      </Modal>

      <Modal size="lg" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <i className="fas fa-edit" style={{ marginRight: 8, color: "#3b82f6" }} />
          Editar Puesto
        </ModalHeader>
        <ModalBody>
          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-user-tie" />
              <span className="form-section-title">Datos del Puesto</span>
            </div>
            <div className="form-section-body">
          <Label className="mr-sm-2">Nombre</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={nombrePuesto}
            required
            onChange={(e) => {
              setNombrePuesto(e.target.value);
            }}
          />
          {/* {user.planteles == PLANTELES_GENERAL ? (
                <div>
                  <Label className="mr-sm-2">Planteles</Label>
                  <Input
                    type="select"
                    value={idPlantelEdit}
                    onChange={(e) => setIdPlantelEdit(e.target.value)}
                  >
                    <option value="0">Selecciona un Plantel</option>
                    {planteles
                      .sort((a, b) => a.name - b.name)
                      .map((a) => {
                          return <option value={a._id}>{a.name}</option>
                      })}
                  </Input>
                </div>
              ) : (
                <div>
                  <Label className="mr-sm-2">Planteles</Label>
                  <Input
                    type="select"
                    value={idPlantelEdit}
                    onChange={(e) => setIdPlantelEdit(e.target.value)}
                  >
                    <option value="0">Selecciona un Plantel </option>
                    {planteles
                      .sort((a, b) => a.name - b.name)
                      .map((a) => {
                        if (a._id == user.planteles) {
                          return <option value={a._id}>{a.name}</option>;
                        }
                      })}
                  </Input>
                </div>
              )} */}
                {/* {user.areas == AREAS_GENERAL ? (
                <div>
                  <Label className="mr-sm-2">Areas</Label>
                  <Input
                    type="select"
                    value={idAreaEdit}
                    required
                    onChange={(e) => setIdAreaEdit(e.target.value)}
                  >
                    <option value="0">Selecciona una Area</option>
                    {areas
                      .sort((a, b) => a.name - b.name)
                      .map((a) => {
                          return <option value={a._id}>{a.name}</option>
                      })}
                  </Input>
                </div>
              ) : (
                <div>
                  <Label className="mr-sm-2">Areas</Label>
                  <Input
                    type="select"
                    value={idAreaEdit}
                    required
                    onChange={(e) => setIdAreaEdit(e.target.value)}
                  >
                    <option value="0">Selecciona una Area</option>
                    {areas
                      .sort((a, b) => a.name - b.name)
                      .map((a) => {
                        if (user.areas == a._id) {
                          return <option value={a._id}>{a.name}</option>;
                        }
                      })}
                  </Input>
                </div>
              )} */}
            <Label className="mr-sm-2">Jefe</Label>
            <Input
                className="col-sm-12"
                type="select"
                value={idColaboradoresEdit}
                required
                onChange={(e) => {
                  setIdColaboradoresEdit(e.target.value);
                }}
              >
                <option value="0">Selecciona una Area</option>
                {colaboradores
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((a) => {
                      return <option value={a._id}>{a.nombre} {a.apellido}</option>;
                  })}
              </Input>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editPuesto}>
            <i className="fas fa-save" style={{ marginRight: 6 }} />Guardar
          </Button>
        </ModalFooter>
      </Modal>
      {loader}
    </>
  );
}

export default ListadoPuestos;
